/* eslint-disable no-param-reassign */
import axios from 'axios';

export default async ({
  params,
  queryClient,
  update,
  videoPropertiesKey,
  videoVersionKey,
  handleBackendErrors,
  versionId,
}) => {
  const type = params.type === 'live' ? 'live_videos' : 'videos';
  const url = `/api/admin/${type}/${params.id}/cover_art${
    versionId ? `?version_id=${versionId}` : ''
  }`;

  if (!update.url) update = {};

  try {
    await axios.put(url, { data: update });
  } catch (error) {
    return handleBackendErrors(error);
  }

  queryClient.invalidateQueries(videoPropertiesKey);
  queryClient.invalidateQueries(videoVersionKey);
};
